import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  TextField,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Alert,
  OutlinedInput,
  Chip,
} from "@mui/material";
// components
import { Editor } from "react-draft-wysiwyg";
import Iconify from "../components/iconify";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import QuestionsTable from "src/components/pickem-admin/QuestionsTable";
import AssetsDialog from "src/components/pickem-admin/AssetsDialog";
import QuestionsOrderingTable from "src/components/pickem-admin/QuestionsOrderingTable";
import EditGeneralSettings from "src/components/pickem-edit/EditGeneralSettings";
import EditTextSettings from "src/components/pickem-edit/EditTextSettings";
import EditPrizeSettings from "src/components/pickem-edit/EditPrizeSettings";
import PickemLeaderboardTable from "src/components/pickem-edit/PickemLeaderboardTable";
import PickemRulesEdit from "src/components/pickem-admin/PickemRulesEdit";

// ----------------------------------------------------------------------

const isOlybet = process.env.REACT_APP_NAME === "olybet";

const getCardFormatQuestionsCount = (cardFormat) => {
  switch (cardFormat) {
    case "three_on_five":
      return 15;
    case "five_on_five":
      return 25;
    default:
      return 15;
  }
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}
const getStatsMatchIds = (pickem) => {
  let matchIds = [];
  for (let i = 0; i < pickem.questions.length; i++) {
    let quesiton = pickem.questions[i];
    for (let j = 0; j < quesiton.options.length; j++) {
      let option = quesiton.options[j];
      if (option?.data?.match_id) {
        matchIds.push(option.data.match_id);
      }
    }
  }
  return matchIds;
};
const dateFormat = "YYYY-MM-DD HH:mm:ss";

export default function PickemEditPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isScoringMode, setIsScoringMode] = useState(false);
  const [isOrderingMode, setIsOrderingMode] = useState(false);
  const [pickemStart, setPickemStart] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [leaderboard, setLeaderboard] = useState(null);
  const [matchStatsIds, setMatchStatsIds] = useState(null);
  const [matchStats, setMatchStats] = useState(null);
  const [pinUserIds, setPinUserIds] = useState(null);
  const [pickemId, setPickemId] = useState(null);

  const [state, setState] = useState({
    title_en: "",
    title_fr: "",
  });

  const [assetsTarget, setAssetsTarget] = useState(null);

  useEffect(() => {
    if (searchParams.has("pickem_id")) {
      let pickemId = searchParams.get("pickem_id");
      setPickemId(pickemId);
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${pickemId}`)
        .then(function (response) {
          setState(response.data.pickem);
          const matchIds = getStatsMatchIds(response.data.pickem);
          if (matchIds.length > 0) {
            setMatchStatsIds(matchIds);
          }
          setPickemStart(moment(response.data.pickem.start, dateFormat));

          setLoading(false);
        });
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-leaderboard/${pickemId}`
        )
        .then(function (response) {
          setLeaderboard(response.data);
          setPinUserIds(response.data.pinedUserIds);
        });
    }
  }, []);

  useEffect(() => {
    if (matchStatsIds !== null) {
      fetchMatchStats();
    }
  }, [matchStatsIds]);

  const fetchMatchStats = async () => {
    try {
      const requests = matchStatsIds.map((matchId) =>
        axios.get(
          `${process.env.REACT_APP_FEED_BASE_URL}/hockey/matches/${matchId}`
        )
      );

      const responses = await Promise.all(requests);
      const combinedMatchStats = responses.map(
        (response) => response.data.match
      );
      setMatchStats(combinedMatchStats.flat());
    } catch (error) {
      console.error("Error fetching match stats:", error);
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleChangePinUser = (userId, index) => {
    pinUserIds[index] = userId;
    setPinUserIds([...pinUserIds]);
  };
  const handleChangeStatus = (event) => {
    setState((prevState) => ({
      ...prevState,
      status: event.target.value,
    }));
  };
  const handleChangeType = (event) => {
    setState((prevState) => ({
      ...prevState,
      pickem_type: event.target.value,
    }));
  };

  const handleChangePrizesBreakdown = (prizesBreakdown) => {
    setState((prevState) => ({
      ...prevState,
      prizesBreakdown: [...prizesBreakdown],
    }));
  };
  const handleChangePrizeDescription = (field, name, value) => {
    if (!state[field]) {
      state[field] = {};
    }

    state[field][name] = value;
    console.log(field, name, value, state);
    setState((prevState) => ({
      ...prevState,
      [field]: { ...state[field] },
    }));
  };

  const handleChangeTenants = (event) => {
    const {
      target: { value },
    } = event;
    setState((prevState) => ({
      ...prevState,
      tenants_prefixes: typeof value === "string" ? value.split(",") : value,
    }));
  };
  const handlePickemStartChange = (newValue) => {
    setPickemStart(newValue);
    setState((prevState) => ({
      ...prevState,
      start: moment(newValue).format(dateFormat), //2022-11-23 23:00:00
    }));
  };
  const handlePickemAllowSelectionsStartChange = (newValue) => {
    setPickemStart(newValue);
    setState((prevState) => ({
      ...prevState,
      allow_selection_start: moment(newValue).format(dateFormat), //2022-11-23 23:00:00
    }));
  };
  const handleSubmitClick = async (e) => {
    setLoading(true);
    e.preventDefault();
    state.pin_user_ids = pinUserIds;
    console.log("state", state);
    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${state.pickem_id}`,
        state
      )
      .then((response) => {
        window.location.reload(false);
      });
  };

  const [value, setValue] = useState(0);

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  const [mainTabValue, setMainTabValue] = useState(0);

  const handleChangeMainTabs = (event, newValue) => {
    setMainTabValue(newValue);
  };

  const [questionsTabValue, setQuestionsTabValue] = useState(0);

  const handleChangeQuestionsTabs = (event, newValue) => {
    setQuestionsTabValue(questionsTabValue);
  };

  const handleDownloadCsv = () => {
    setLoading(true);
    axios({
      url: `${process.env.REACT_APP_API_BASE_URL}/admin/leaderboard/export-csv/${pickemId}`,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const now = new Date();
        const dateTime = now.toISOString().slice(0, 16).replace("T", " ");
        link.setAttribute(
          "download",
          `leaderboard-pickem-${pickemId} ${dateTime}.csv`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error during CSV download", error);
        setLoading(false);
      });
  };

  const deleteQuestionHandler = (index) => {
    axios
      .delete(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-questions/${state.pickem_id}?question_id=${state.questions[index].question_id}`
      )
      .then((response) => {
        window.location.reload(false);
      });
  };

  const optionClickHandler = (questionId, optionId) => {
    if (isScoringMode) {
      let questionIndex = state.questions.findIndex(
        (question) => question.question_id === questionId
      );
      if (questionIndex !== -1) {
        let optionIndex = state.questions[questionIndex].options.findIndex(
          (option) => option.option_id === optionId
        );

        if (optionIndex !== -1) {
          let isCorrect =
            state.questions[questionIndex].options[optionIndex]?.is_correct &&
            state.questions[questionIndex].options[optionIndex].is_correct
              ? false
              : true;
          state.questions[questionIndex].options[optionIndex].is_correct =
            isCorrect;
          setState({ ...state });
        }
      }
    }
  };

  const bonusOptionClickHandler = (questionId, optionLabel) => {
    if (isScoringMode) {
      let questionIndex = state.questions.findIndex(
        (question) => question.question_id === questionId
      );
      if (questionIndex !== -1) {
        let optionIndex = state.questions[
          questionIndex
        ].bonus_options.findIndex((option) => option.label == optionLabel);

        if (optionIndex !== -1) {
          let isCorrect =
            state.questions[questionIndex].bonus_options[optionIndex]
              ?.is_correct &&
            state.questions[questionIndex].bonus_options[optionIndex].is_correct
              ? false
              : true;
          state.questions[questionIndex].bonus_options[optionIndex].is_correct =
            isCorrect;
          setState({ ...state });
        }
      }
    }
  };

  const updateQuestions = () => {
    setLoading(true);
    let questionUpdatePromises = [];

    for (let i = 0; i < state.questions.length; i++) {
      let question = state.questions[i];
      questionUpdatePromises.push(
        axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-questions/${state.pickem_id}?question_id=${question.question_id}`,
          question
        )
      );
    }

    Promise.all(questionUpdatePromises)
      .then((response) => {
        window.location.reload(false);
      })
      .catch((error) => console.log("Update questions ERROR", error));
  };

  const reorderQuestionsHandler = (questions) => {
    state.questions = questions;
    setState({ ...state });
  };

  const QuestionsButtons = () => (
    <Box>
      {!isScoringMode && !isOrderingMode ? (
        <>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="eva:toggle-left-outline" />}
            onClick={() => setIsScoringMode(true)}
            sx={{ mr: 2 }}
          >
            Scoring Mode
          </Button>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="eva:toggle-left-outline" />}
            onClick={() => setIsOrderingMode(true)}
            sx={{ mr: 2 }}
          >
            Re-Ordering Mode
          </Button>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() =>
              navigate(
                `/dashboard/pickem/question?pickem_id=${state.pickem_id}`
              )
            }
          >
            Create Question
          </Button>
        </>
      ) : null}
      {isScoringMode ? (
        <>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="eva:close-outline" />}
            onClick={() => setIsScoringMode(false)}
            sx={{ mr: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="eva:save-outline" />}
            onClick={() => updateQuestions()}
            sx={{ mr: 2 }}
          >
            Update Questons
          </Button>
        </>
      ) : null}
      {isOrderingMode ? (
        <>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="eva:close-outline" />}
            onClick={() => setIsOrderingMode(false)}
            sx={{ mr: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            startIcon={<Iconify icon="eva:save-outline" />}
            onClick={() => updateQuestions()}
            sx={{ mr: 2 }}
          >
            Save Order
          </Button>
        </>
      ) : null}
    </Box>
  );
  const deleteImage = (key) => {
    setState((prevState) => ({
      ...prevState,
      [key]: null,
    }));
  };
  const onChoseAsset = (assetUrl) => {
    setState((prevState) => ({
      ...prevState,
      [assetsTarget]: assetUrl,
    }));
    setAssetsTarget(null);
  };
  const onCloseAssetsDialog = (assetUrl) => {
    setAssetsTarget(null);
  };

  const handleForceTournamentsScoring = () => {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${state.pickem_id}/run-tournaments-leaderboard-scoring`
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };
  const handleForcePickemScoring = () => {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${state.pickem_id}/run-leaderboard-scoring`
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };
  const handleForceLeaderboardSync = () => {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${state.pickem_id}/run-leaderboard-sync`
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  console.log(state);
  return (
    <>
      <Helmet>
        <title> Pickem Edit </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Pickem Edit
          </Typography>

          <Box>
            <Button
              variant="outlined"
              startIcon={<Iconify icon="eva:close-outline" />}
              onClick={() => navigate(`/dashboard/pickems`)}
              sx={{ mr: 2 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:save-outline" />}
              onClick={handleSubmitClick}
            >
              Save
            </Button>
          </Box>
        </Stack>

        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={mainTabValue}
              onChange={handleChangeMainTabs}
              aria-label="basic tabs example"
            >
              <Tab label="General Settings" {...a11yProps(0)} />
              <Tab label="Questions" {...a11yProps(1)} />
              <Tab label="Prizing" {...a11yProps(2)} />
              <Tab label="Leaderboard" {...a11yProps(3)} />
              <Tab label="Rules" {...a11yProps(5)} />
            </Tabs>
          </Box>
          <TabPanel value={mainTabValue} index={0}>
            <EditGeneralSettings
              loading={loading}
              state={state}
              handleChangeStatus={handleChangeStatus}
              handleChangeType={handleChangeType}
              handleChangeTenants={handleChangeTenants}
              handlePickemStartChange={handlePickemStartChange}
              handlePickemAllowSelectionsStartChange={
                handlePickemAllowSelectionsStartChange
              }
            />
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChangeTabs}
                  aria-label="basic tabs example"
                >
                  <Tab label="English" {...a11yProps(0)} />
                  <Tab label="French" {...a11yProps(1)} />
                  <Tab label="Slovak" {...a11yProps(2)} />
                  <Tab label="Estonian" {...a11yProps(3)} />
                  <Tab label="Latvian" {...a11yProps(4)} />
                  <Tab label="Lithuanian" {...a11yProps(4)} />
                  <Tab label="Russian" {...a11yProps(6)} />
                  {!isOlybet && <Tab label="Spanish" {...a11yProps(8)} />}
                  {!isOlybet && <Tab label="German" {...a11yProps(8)} />}
                </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <EditTextSettings
                  loading={loading}
                  state={state}
                  lang="en"
                  setAssetsTarget={setAssetsTarget}
                  deleteImage={deleteImage}
                  handleChange={handleChange}
                  handleChangePrizeDescription={handleChangePrizeDescription}
                />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <EditTextSettings
                  loading={loading}
                  state={state}
                  lang="fr"
                  setAssetsTarget={setAssetsTarget}
                  deleteImage={deleteImage}
                  handleChange={handleChange}
                  handleChangePrizeDescription={handleChangePrizeDescription}
                />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <EditTextSettings
                  loading={loading}
                  state={state}
                  lang="sl"
                  setAssetsTarget={setAssetsTarget}
                  deleteImage={deleteImage}
                  handleChange={handleChange}
                  handleChangePrizeDescription={handleChangePrizeDescription}
                />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <EditTextSettings
                  loading={loading}
                  state={state}
                  lang="es"
                  setAssetsTarget={setAssetsTarget}
                  deleteImage={deleteImage}
                  handleChange={handleChange}
                  handleChangePrizeDescription={handleChangePrizeDescription}
                />
              </TabPanel>
              <TabPanel value={value} index={4}>
                <EditTextSettings
                  loading={loading}
                  state={state}
                  lang="lv"
                  setAssetsTarget={setAssetsTarget}
                  deleteImage={deleteImage}
                  handleChange={handleChange}
                  handleChangePrizeDescription={handleChangePrizeDescription}
                />
              </TabPanel>
              <TabPanel value={value} index={5}>
                <EditTextSettings
                  loading={loading}
                  state={state}
                  lang="lt"
                  setAssetsTarget={setAssetsTarget}
                  deleteImage={deleteImage}
                  handleChange={handleChange}
                  handleChangePrizeDescription={handleChangePrizeDescription}
                />
              </TabPanel>
              <TabPanel value={value} index={6}>
                <EditTextSettings
                  loading={loading}
                  state={state}
                  lang="rus"
                  setAssetsTarget={setAssetsTarget}
                  deleteImage={deleteImage}
                  handleChange={handleChange}
                  handleChangePrizeDescription={handleChangePrizeDescription}
                />
              </TabPanel>
              <TabPanel value={value} index={7}>
                <EditTextSettings
                  loading={loading}
                  state={state}
                  lang="esp"
                  setAssetsTarget={setAssetsTarget}
                  deleteImage={deleteImage}
                  handleChange={handleChange}
                  handleChangePrizeDescription={handleChangePrizeDescription}
                />
              </TabPanel>
              <TabPanel value={value} index={8}>
                <EditTextSettings
                  loading={loading}
                  state={state}
                  lang="de"
                  setAssetsTarget={setAssetsTarget}
                  deleteImage={deleteImage}
                  handleChange={handleChange}
                  handleChangePrizeDescription={handleChangePrizeDescription}
                />
              </TabPanel>
            </Box>
          </TabPanel>
          <TabPanel value={mainTabValue} index={1}>
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChangeTabs}
                  aria-label="basic tabs example"
                >
                  <Tab label="English" {...a11yProps(0)} />
                  <Tab label="French" {...a11yProps(1)} />
                  <Tab label="Slovak" {...a11yProps(2)} />
                  <Tab label="Estonian" {...a11yProps(3)} />
                  <Tab label="Latvian" {...a11yProps(4)} />
                  <Tab label="Lithuanian" {...a11yProps(5)} />
                  <Tab label="Russian" {...a11yProps(6)} />
                  {!isOlybet && <Tab label="Spanish" {...a11yProps(7)} />}
                  {!isOlybet && <Tab label="German" {...a11yProps(8)} />}
                </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={0}
                  mt={3}
                >
                  <Typography variant="h4" gutterBottom>
                    Questions
                  </Typography>
                  <QuestionsButtons />
                </Stack>
                <Card sx={{ padding: 1, marginTop: 1 }}>
                  {loading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center" }}
                      style={{ padding: 20 }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      {isOrderingMode ? (
                        <QuestionsOrderingTable
                          questions={state.questions}
                          reorderHandler={reorderQuestionsHandler}
                        />
                      ) : (
                        <QuestionsTable
                          lang={"en"}
                          questions={state.questions}
                          pickemId={state.pickem_id}
                          deleteQuestionHandler={deleteQuestionHandler}
                          optionClickHandler={optionClickHandler}
                          bonusOptionClickHandler={bonusOptionClickHandler}
                          showActions={true}
                          matchStats={matchStats}
                        />
                      )}
                    </>
                  )}
                </Card>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={0}
                  mt={3}
                >
                  <Typography variant="h4" gutterBottom>
                    Questions
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<Iconify icon="eva:plus-outline" />}
                    onClick={() =>
                      navigate(
                        `/dashboard/pickem/question?pickem_id=${state.pickem_id}`
                      )
                    }
                  >
                    Create Question
                  </Button>
                </Stack>
                <Card sx={{ padding: 1, marginTop: 1 }}>
                  {loading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center" }}
                      style={{ padding: 20 }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <QuestionsTable
                        lang={"fr"}
                        questions={state.questions}
                        pickemId={state.pickem_id}
                        deleteQuestionHandler={deleteQuestionHandler}
                        optionClickHandler={optionClickHandler}
                        bonusOptionClickHandler={bonusOptionClickHandler}
                        showActions={true}
                      />
                    </>
                  )}
                </Card>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={0}
                  mt={3}
                >
                  <Typography variant="h4" gutterBottom>
                    Questions
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<Iconify icon="eva:plus-outline" />}
                    onClick={() =>
                      navigate(
                        `/dashboard/pickem/question?pickem_id=${state.pickem_id}`
                      )
                    }
                  >
                    Create Question
                  </Button>
                </Stack>
                <Card sx={{ padding: 1, marginTop: 1 }}>
                  {loading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center" }}
                      style={{ padding: 20 }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <QuestionsTable
                        lang={"sl"}
                        questions={state.questions}
                        pickemId={state.pickem_id}
                        deleteQuestionHandler={deleteQuestionHandler}
                        optionClickHandler={optionClickHandler}
                        bonusOptionClickHandler={bonusOptionClickHandler}
                        showActions={true}
                      />
                    </>
                  )}
                </Card>
              </TabPanel>
              <TabPanel value={value} index={3}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={0}
                  mt={3}
                >
                  <Typography variant="h4" gutterBottom>
                    Questions
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<Iconify icon="eva:plus-outline" />}
                    onClick={() =>
                      navigate(
                        `/dashboard/pickem/question?pickem_id=${state.pickem_id}`
                      )
                    }
                  >
                    Create Question
                  </Button>
                </Stack>
                <Card sx={{ padding: 1, marginTop: 1 }}>
                  {loading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center" }}
                      style={{ padding: 20 }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <QuestionsTable
                        lang={"es"}
                        questions={state.questions}
                        pickemId={state.pickem_id}
                        deleteQuestionHandler={deleteQuestionHandler}
                        optionClickHandler={optionClickHandler}
                        bonusOptionClickHandler={bonusOptionClickHandler}
                        showActions={true}
                      />
                    </>
                  )}
                </Card>
              </TabPanel>
              <TabPanel value={value} index={4}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={0}
                  mt={3}
                >
                  <Typography variant="h4" gutterBottom>
                    Questions
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<Iconify icon="eva:plus-outline" />}
                    onClick={() =>
                      navigate(
                        `/dashboard/pickem/question?pickem_id=${state.pickem_id}`
                      )
                    }
                  >
                    Create Question
                  </Button>
                </Stack>
                <Card sx={{ padding: 1, marginTop: 1 }}>
                  {loading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center" }}
                      style={{ padding: 20 }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <QuestionsTable
                        lang={"lv"}
                        questions={state.questions}
                        pickemId={state.pickem_id}
                        deleteQuestionHandler={deleteQuestionHandler}
                        optionClickHandler={optionClickHandler}
                        bonusOptionClickHandler={bonusOptionClickHandler}
                        showActions={true}
                      />
                    </>
                  )}
                </Card>
              </TabPanel>
              <TabPanel value={value} index={5}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={0}
                  mt={3}
                >
                  <Typography variant="h4" gutterBottom>
                    Questions
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<Iconify icon="eva:plus-outline" />}
                    onClick={() =>
                      navigate(
                        `/dashboard/pickem/question?pickem_id=${state.pickem_id}`
                      )
                    }
                  >
                    Create Question
                  </Button>
                </Stack>
                <Card sx={{ padding: 1, marginTop: 1 }}>
                  {loading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center" }}
                      style={{ padding: 20 }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <QuestionsTable
                        lang={"lt"}
                        questions={state.questions}
                        pickemId={state.pickem_id}
                        deleteQuestionHandler={deleteQuestionHandler}
                        optionClickHandler={optionClickHandler}
                        bonusOptionClickHandler={bonusOptionClickHandler}
                        showActions={true}
                      />
                    </>
                  )}
                </Card>
              </TabPanel>
              <TabPanel value={value} index={6}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={0}
                  mt={3}
                >
                  <Typography variant="h4" gutterBottom>
                    Questions
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<Iconify icon="eva:plus-outline" />}
                    onClick={() =>
                      navigate(
                        `/dashboard/pickem/question?pickem_id=${state.pickem_id}`
                      )
                    }
                  >
                    Create Question
                  </Button>
                </Stack>
                <Card sx={{ padding: 1, marginTop: 1 }}>
                  {loading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center" }}
                      style={{ padding: 20 }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <QuestionsTable
                        lang={"rus"}
                        questions={state.questions}
                        pickemId={state.pickem_id}
                        deleteQuestionHandler={deleteQuestionHandler}
                        optionClickHandler={optionClickHandler}
                        bonusOptionClickHandler={bonusOptionClickHandler}
                        showActions={true}
                      />
                    </>
                  )}
                </Card>
              </TabPanel>
              <TabPanel value={value} index={7}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={0}
                  mt={3}
                >
                  <Typography variant="h4" gutterBottom>
                    Questions
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<Iconify icon="eva:plus-outline" />}
                    onClick={() =>
                      navigate(
                        `/dashboard/pickem/question?pickem_id=${state.pickem_id}`
                      )
                    }
                  >
                    Create Question
                  </Button>
                </Stack>
                <Card sx={{ padding: 1, marginTop: 1 }}>
                  {loading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center" }}
                      style={{ padding: 20 }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <QuestionsTable
                        lang={"esp"}
                        questions={state.questions}
                        pickemId={state.pickem_id}
                        deleteQuestionHandler={deleteQuestionHandler}
                        optionClickHandler={optionClickHandler}
                        bonusOptionClickHandler={bonusOptionClickHandler}
                        showActions={true}
                      />
                    </>
                  )}
                </Card>
              </TabPanel>
              <TabPanel value={value} index={8}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={0}
                  mt={3}
                >
                  <Typography variant="h4" gutterBottom>
                    Questions
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<Iconify icon="eva:plus-outline" />}
                    onClick={() =>
                      navigate(
                        `/dashboard/pickem/question?pickem_id=${state.pickem_id}`
                      )
                    }
                  >
                    Create Question
                  </Button>
                </Stack>
                <Card sx={{ padding: 1, marginTop: 1 }}>
                  {loading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center" }}
                      style={{ padding: 20 }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <QuestionsTable
                        lang={"de"}
                        questions={state.questions}
                        pickemId={state.pickem_id}
                        deleteQuestionHandler={deleteQuestionHandler}
                        optionClickHandler={optionClickHandler}
                        bonusOptionClickHandler={bonusOptionClickHandler}
                        showActions={true}
                      />
                    </>
                  )}
                </Card>
              </TabPanel>
            </Box>
          </TabPanel>
          <TabPanel value={mainTabValue} index={2}>
            <EditPrizeSettings
              loading={loading}
              handleChangePrizesBreakdown={handleChangePrizesBreakdown}
              state={state}
            />
          </TabPanel>
          <TabPanel value={mainTabValue} index={3}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={5}
            >
              <Box>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:list-outline" />}
                  onClick={() => handleForceTournamentsScoring()}
                  sx={{ mr: 2 }}
                >
                  Update All Leaderboards
                </Button>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:rewind-right-outline" />}
                  onClick={() => handleForcePickemScoring()}
                  sx={{ mr: 2 }}
                >
                  Score Daily Leaderboard
                </Button>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:rewind-right-outline" />}
                  onClick={() => handleForceLeaderboardSync()}
                  sx={{ mr: 2 }}
                >
                  Sync with Gamezone
                </Button>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:download-outline" />}
                  onClick={() => handleDownloadCsv()}
                >
                  Export Csv
                </Button>
              </Box>
            </Stack>
            <Box sx={{ mb: 2 }}>
              {leaderboard !== null ? (
                <>
                  <Alert sx={{ marginTop: 2 }} severity="info">
                    {`Daily Leaderboard Scoring progress: ${leaderboard.completedScoringCount} / ${leaderboard.selectionsCount} `}
                  </Alert>
                  <Alert sx={{ marginTop: 2 }} severity="info">
                    {`Tournament Scoring progress: ${leaderboard.completedTournamentsScoringCount} / ${leaderboard.selectionsCount}`}
                  </Alert>
                </>
              ) : null}
            </Box>
            <Card sx={{ padding: 4, marginBottom: 4 }}>
              {pinUserIds === null ? (
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  style={{ padding: 20 }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <TextField
                        id="pin_user_id_0"
                        label="Leaderboard Pin User ID 1"
                        fullWidth
                        value={pinUserIds[0] ?? ""}
                        variant="standard"
                        onChange={(e) => handleChangePinUser(e.target.value, 0)}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="pin_user_id_1"
                        label="Leaderboard Pin User ID 2"
                        fullWidth
                        value={pinUserIds[1] ?? ""}
                        variant="standard"
                        onChange={(e) => handleChangePinUser(e.target.value, 1)}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        id="pin_user_id_2"
                        label="Leaderboard Pin User ID 3"
                        fullWidth
                        value={pinUserIds[2] ?? ""}
                        variant="standard"
                        onChange={(e) => handleChangePinUser(e.target.value, 2)}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
            </Card>
            {state !== null && (
              <PickemLeaderboardTable pickemId={state.pickem_id} />
            )}
          </TabPanel>
          <TabPanel value={mainTabValue} index={4}>
            <PickemRulesEdit pickemId={state.pickem_id} />
          </TabPanel>
        </Box>
      </Container>
      {assetsTarget !== null ? (
        <AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
      ) : null}
    </>
  );
}
